import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "sw-dl44-luke-bespin",
  name: `DL-44 Blaster\nLuke Bespin (Denix Conversion)`,
  nameFormatted: {
    primary: "DL-44 Blaster",
    secondary: "Luke Bespin (Denix Conversion)",
  },
  origin: "Star Wars: Episode 5 - The Empire Strikes Back",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
